'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { toast } from 'sonner'
import {
  FAST_LOGIN_QUERY_PARAM,
  type FastLoginErrorReason,
} from '@/lib/fast-login/short-code'

const TOAST_ID = 'fast-login-error'
const TOAST_DURATION_MS = 8000

const FAST_LOGIN_ERROR_MESSAGES: Record<FastLoginErrorReason, string> = {
  expired:
    'Link de login rápido expirado ou inválido. Solicite um novo link ao suporte.',
  rate_limited:
    'Muitas tentativas de login rápido. Aguarde um minuto e tente novamente.',
  unavailable:
    'Não foi possível validar o link de login rápido agora. Tente novamente em instantes.',
}

function isFastLoginErrorReason(
  reason: string
): reason is FastLoginErrorReason {
  return reason in FAST_LOGIN_ERROR_MESSAGES
}

/**
 * Mostra o erro do link curto de fast-login quando `/l/[code]` redireciona
 * para cá com `?fast_login=<motivo>`. Não renderiza nada.
 */
export function FastLoginErrorToast() {
  const searchParams = useSearchParams()
  const reason = searchParams.get(FAST_LOGIN_QUERY_PARAM)

  useEffect(() => {
    if (!(reason && isFastLoginErrorReason(reason))) {
      return
    }

    toast.error(FAST_LOGIN_ERROR_MESSAGES[reason], {
      id: TOAST_ID,
      duration: TOAST_DURATION_MS,
    })
  }, [reason])

  return null
}
